import React, { useState } from 'react';

const InspectionObjectionWithdrawalModal = ({ 
  isOpen, 
  onClose, 
  address,
  contract, 
  onSubmit
}) => {
//   const [objectionText, setObjectionText] = useState('');

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
        <h2 className="text-xl font-semibold mb-4">Inspection Objection Withdrawal</h2>
        <p className="text-sm text-gray-700 mb-4">
          You are about to submit a withdrawal to your Inspection objection on <span className="font-bold">{address}</span>.
        </p>
        {/* <textarea 
          className="w-full border rounded p-2 mb-4"
          rows="5"
          value={objectionText}
          onChange={(e) => setObjectionText(e.target.value)}
          placeholder="Enter your objection details here..."
        /> */}
        <p className="text-xs text-gray-600 mb-4">
          Withdrawing your objection means you are agreeing to the current state of the property as-is. 
        </p>
        <div className="flex justify-end gap-4">
          <button 
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400"
          >
            Cancel
          </button>
          <button 
            onClick={() => onSubmit(contract)}
            className="px-4 py-2 bg-shi-green text-white rounded hover:bg-green-700"
          >
            Sign and Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default InspectionObjectionWithdrawalModal;
